const TeamConf = {
  team: [
    {
      logo: "team_gonzalo.png",
      title: "Gonzalo Camiña",
      post: "CEO & Co-Founder",
      href: "https://www.linkedin.com/in/gonzalocaminaceballos/",
    },
    {
      logo: "team_carlos-raposo.png",
      title: "Carlos Rodríguez",
      post: "CPO & Co-Founder",
      href: "https://www.linkedin.com/in/carlosrodriguezraposo",
    },
    {
      logo: "team_lucie.png",
      title: "Lucie Hefnerová",
      post: "CTO & Co-Founder",
      href: "https://www.linkedin.com/in/luciehefnerova/",
    },
    {
      logo: "team_carlos-casanueva.png",
      title: "Carlos Casanueva",
      post: "Non-Executive Chairman & Co-Founder",
      href: "https://www.linkedin.com/in/carlos-casanueva-nárdiz-1a61777",
    },
    {
      logo: "team_patxi.png",
      title: "Patxi Granero",
      post: "Strategy, Finance & Institutional Relations",
      href: "https://www.linkedin.com/in/patxigranero/",
    },

    {
      logo: "team_rosana.png",
      title: "Rosana Llilart",
      post: "Software Quality Assurance Engineer",
      href: "https://www.linkedin.com/in/roxanaguibert/",
    },
    {
      logo: "team_pablo.png",
      title: "Pablo Coello",
      post: "Data Engineer & Business Intelligence",
      href: "https://www.linkedin.com/in/pablo-coello-pulido-76b946142/",
    },
  ],
};

export default TeamConf;



// WEBPACK FOOTER //
// ./src/containers/team/TeamConf.js